// Render Ghost page content
import React, { useState, useEffect } from "react";
import useApi from "../../hooks/UseApi";

const GhostContentPage = (props) => {
  const { ghost } = useApi();
  const [content, setContent] = useState({});
  useEffect(() => {
    window.scrollTo(0, 0);
    ghost(`pages/slug/${props.slug}`).then((data) => {
      setContent(data.pages[0]);
    });
  }, []);
  return (
    <span
      className="component-ghost-content-page"
      dangerouslySetInnerHTML={{ __html: content?.html }}
    ></span>
  );
};
export default GhostContentPage;
